const theme = {
  white: "#ffffff",
  black: "#0a0a0a",
  blue: "#e4edf6",
  orange: "#f07e07",
  grey: "#f7f7f7",
};

module.exports = theme;